export default {
  content: {
    left: 0,
    right: 0,
    bottom: 0,
    position: 'relative',
    border: 'none',
    background: 'transparent',
    padding: 0,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'scroll',
  },
};